import React from 'react';
import classnames from 'classnames';
import { isEmpty } from 'lodash';
import { activeConsultationPackages } from '@fiverr-private/consultation';
import { getContext } from '@fiverr-private/fiverr_context';
import { I18n } from '@fiverr-private/i18n-react';
import { Avatar } from '@fiverr-private/fit';
import { Container, Stack } from '@fiverr-private/layout_components';
import { HourlyRate, ProUserInfoContainer } from '@fiverr-private/seller_pages_toolbox';
import { SOURCES } from '../../../monitoring/monitoring-constants';
import { ContactButton } from '../../common/ActionButtons';
import { RespondTimeInfo } from '../../common/Info';
import { useSellerVacation } from '../hooks/useSellerVacation';
import { ConsultationButton } from '../ConsultationButton';
import { useFreelancerPageContext } from '../../FreelancerPageContext';
import { useRolloutContext } from '../../../contexts/RolloutContext';
import styles from './index.module.scss';

const T_PREFIX = 'freelancer_page.contact';

/** @type {import('./index').ContactCard} */
export const ContactCard = ({
    className,
    username,
    respondHours,
    withTitle = true,
    timeZone,
    isOnline,
    newView,
    user,
}) => {
    const { isMobile } = getContext();
    const { isOnVacation } = useSellerVacation();
    const { consultationData, seller } = useFreelancerPageContext();
    const hasConsultation = !isEmpty(consultationData) && !!activeConsultationPackages(consultationData.pricing).length;

    const displayName = user?.profile?.displayName || username;
    const { inZebrasHourlyRateRollout } = useRolloutContext();
    const hourlyEligible = !!seller?.benefits?.hourly?.eligible;

    return (
        <div className={classnames(className, styles.contactCard, 'p-32 box-shadow-z1')}>
            {newView && (
                <div className={styles.avatarBox}>
                    <div className="m-r-16">
                        <Avatar
                            size={48}
                            username={user?.name}
                            src={user?.profileImageUrl}
                            isOnline={isOnline}
                            showOnlineIndicator={isOnline}
                            onlineIndicatorSize={8}
                            onlineIndicatorPosition={Avatar.ONLINE_INDICATOR_POSITIONS.BOTTOM_RIGHT}
                        />
                    </div>
                    <Container width="100%">
                        <Stack direction="column" width="100%" className="text-display-6 m-b-8">
                            <Stack direction="column" gap="0" justifyContent="flexStart" width="100%">
                                <span>{displayName}</span>
                                {inZebrasHourlyRateRollout && hourlyEligible && (
                                    <HourlyRate hourlyRateInUsdCents={seller?.hourlyRate?.priceInCents} />
                                )}
                            </Stack>
                        </Stack>
                        <ProUserInfoContainer timeZone={timeZone} isOnline={isOnline} />
                    </Container>
                </div>
            )}
            {!newView && withTitle && !isOnVacation && (
                <div className="flex flex-center co-text-darker text-semi-bold">
                    <I18n k={`${T_PREFIX}.title`} />
                </div>
            )}

            <ContactButton
                className={classnames(styles.contactButton, 'm-t-20 m-b-16')}
                username={username}
                size="lg"
                source={SOURCES.page}
                renderDropdown={true}
                shouldRenderFloatingBtn={!isMobile}
            />

            {hasConsultation && <ConsultationButton />}

            <RespondTimeInfo respondHours={respondHours} />
        </div>
    );
};
